import { render, staticRenderFns } from "./FilterSelected.vue?vue&type=template&id=10a12295&"
import script from "./FilterSelected.vue?vue&type=script&lang=js&"
export * from "./FilterSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VFlex})
